import { ref } from 'vue';
import ApiService from '../services/api.service';
import AlertService from '../services/errors.service';
import { useRouter } from 'vue-router';

export default function useUsers() {
  const Users = ref({});
  const router = useRouter();

  const User = ref([]);
  const isEmployeeLoading = ref(true);
  const selectUser = ref([]);
  const employeeUserList = ref([]);
  const employeeAllUserList = ref([]);
  const responseResult = ref(false);

  const getUsers = async (query) => {
    return await ApiService.get('/user?' + new URLSearchParams(query));
  };
  const fetchEmployeeUsers = async () => {
    return await ApiService.get('/user/employee').then((response) => {
      employeeUserList.value = response.data.data;
    });
  };
  const fetchEmployeeAllUsers = async () => {
    return await ApiService.get('/user/all-employee').then((response) => {
      employeeAllUserList.value = response.data.data;
    });
  };
  const fetchLeaveRequestOverviewEmployees = async () => {
    return await ApiService.get('/leave/leave-request/overview-employees').then((response) => {
      employeeAllUserList.value = response.data.data;
    });
  };

  const getUser = async (id) => {
    let response = await ApiService.get('/user/' + id);
    User.value = response.data.data;
  };

  const getUserData = async () => {
    return await ApiService.get('/user/permissions');
  };

  // get user profile but id is not optional

  const getUserProfile = async (id = null) => {
    let response;
    if (id == null) {
      response = await ApiService.get('/user/profile');
    } else {
      response = await ApiService.get('/user/profile/' + id);
    }
    User.value = response.data.data;
  };

  const selectUsers = async () => {
    let response = await ApiService.get('/user/select2');
    selectUser.value = response.data.data;
  };

  const getUserEditData = async (id) => {
    try {
      isEmployeeLoading.value = true;
      let response = await ApiService.get('/user/' + id + '/edit');
      let data = response.data.data;
      data.active = data.active == 1 ? true : false;
      User.value = data;
    } catch (error) {
      responseResult.value = false;
    } finally {
      isEmployeeLoading.value = false;
    }
  };

  const storeUser = async (data) => {
    try {
      const response = await ApiService.post('/user', data);

      if (response.status === 201) {
        AlertService.successMessage(response.data.message);
        router.push('/employees');
      }
    } catch (error) {
      responseResult.value = false;
    }
  };

  const updateUser = async (id, data) => {
    try {
      if (data.parent_id == null) {
        delete data.parent_id;
      }

      const response = await ApiService.post('user/' + id, data);

      if (response.status === 200) {
        AlertService.successMessage(response.data.message);
        responseResult.value = true;
        router.push('/employees');
      }
    } catch (error) {
      responseResult.value = false;
    }
  };

  const destroyUser = async (id) => {
    try {
      const response = await ApiService.delete('/user/' + id);

      if (response.status === 200) {
        AlertService.successMessage(response.data.message);
        responseResult.value = true;
      }
    } catch (error) {}
  };

  const changeUserStatus = async (id) => {
    try {
      const response = await ApiService.get('/user/' + id + '/status');

      if (response.status === 200) {
        AlertService.successMessage(response.data.message);
        responseResult.value = true;
      }
    } catch (error) {
      responseResult.value = false;
    }
  };

  const changeUserPassword = async (data) => {
    try {
      const response = await ApiService.put('/user/password', data);
      if (response.status === 200) {
        AlertService.successMessage(response.data.message);
      }
    } catch (error) {}
  };

  const changeUserAvatar = async (data) => {
    try {
      const response = await ApiService.post('/user/image', data);
      if (response.status === 200) {
        AlertService.successMessage(response.data.message);
        localStorage.removeItem('userImage');
        localStorage.setItem('userImage', JSON.stringify(response.data.image));
      }
    } catch (error) {}
  };

  return {
    isEmployeeLoading,
    employeeUserList,

    fetchEmployeeUsers,
    employeeAllUserList,
    fetchEmployeeAllUsers,
    fetchLeaveRequestOverviewEmployees,
    User,
    Users,
    selectUser,
    responseResult,
    getUser,
    getUsers,
    getUserData,
    getUserProfile,
    changeUserPassword,
    changeUserAvatar,
    getUserEditData,
    selectUsers,
    storeUser,
    updateUser,
    destroyUser,
    changeUserStatus
  };
}
